import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { useIntl } from "react-intl";
import Checkbox from "../../../../common/Checkbox";
import { formatNumber } from "../NumberFormatUtils";

export const HeaderOptions = ({
                                  table,
                                  handleBeginningClick,
                                  subquestionModifiedId,
                                  sinceBeginning
                              }) => {
    const intl = useIntl();
    return (
        <div className="d-flex align-items-center flex-shrink-0 ms-3">
            <ButtonGroup className="me-2">
                <Checkbox
                    name={table.questionId}
                    value={table.questionKey || table.questionId}
                    type="checkbox"
                    onChange={(e) => handleBeginningClick(e, e.target.checked, subquestionModifiedId)}
                    checked={!!sinceBeginning[table.questionId]}
                    onClick={e => e.stopPropagation()}
                >
                    {intl.formatMessage({id: "collapsible.filter.sinceFundingStarted"})}
                </Checkbox>
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip id={`toolbar-button-warning-${table.questionId}`}>
                            {intl.formatMessage({id: "collapsible.filter.sinceFundingStarted.text"})}
                        </Tooltip>
                    }
                >
                    <FontAwesomeIcon icon={faQuestionCircle} className="ms-1"/>
                </OverlayTrigger>
            </ButtonGroup>
            <ButtonGroup className="d-flex align-items-center justify-content-center">
                <Badge variant="primary" title={intl.formatMessage({id: "indicator.chart.legend.project.amount"})}>
                    n={formatNumber(table.periodCount)}
                </Badge>
            </ButtonGroup>
        </div>
    );
};
